import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/page/home'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import("@/page/home"),
      meta:{
        title:'首页',
        show:true
      }
    },
    {
      path: '/aboutUs',
      name: 'aboutUs',
      component: () => import("@/page/aboutUs"),
      meta:{
        title:'关于我们',
        show:true
      }
    },
    {
      path: '/wap',
      name: 'wap',
      component: () => import("@/page/homeWap"),
      meta:{
        title:'移动',
        show:false
      }
    },
        // 用户协议与隐私政策
    {
          path: '/previewAgreement/:fileUrl/:fileName',
          name: 'previewAgreement',
          component: () =>
            import("@/page/previewAgreement"),
          meta: {
            show:false
          }
    }
  ],
  mode:'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js